import "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";
import config from "../helpers/config.js";
import $ from "jquery";

export default class Questions extends Phaser.Scene {
  constructor() {
    super(cst.scenes.questions);
  }

  init(data) {
    this.question = data.question;
    this.points = data.points;
  }

  create() {
    this.scene.bringToTop();
    this.checkboxes = [];
    this.options = [];
    this.value = [];

    this.sndCorrect = this.sound.add("snd-correct", {
      volume: 0.5,
    });
    this.sndWrong = this.sound.add("snd-wrong", {
      volume: 1,
    });

    this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2,
        "bg-overlay",
      )
      .setAlpha(0.5);

    this.box = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      `box-question-${this.question.category}`,
    );

    this.txtTop = this.add.text(
      this.cameras.main.width / 2 - 275,
      this.cameras.main.height / 2 - 325,
      this.question.question,
      cst.textstyles.question,
    );

    for (let i = 1; i < 6; i++) {
      if (this.question[`option_${i}`] !== null) {
        const txtOption = this.add.text(
          this.cameras.main.width / 2 - 200, //For PC => 205 // For Mobile => 200
          this.cameras.main.height / 2 - 235 + i * 100,
          this.question[`option_${i}`],
          cst.textstyles.answer,
        );

        const btnCheckBox = this.add
          .image(
            this.cameras.main.width / 2 - 240,
            this.cameras.main.height / 2 - 223 + i * 100,
            "checkbox-bw",
          )
          .setScale(1.8) //For PC => .setScale(1.2) // For Mobile => .setScale(1.8)
          .setData("option", i)
          .setInteractive({ useHandCursor: true })
          .on("pointerdown", () =>
            buttonBehaviours.pushOnClick(this, btnCheckBox, () => {
              this.btnShowAnswer
                .setTexture("btn-next")
                .setInteractive({ useHandCursor: true });
              this.checkboxSelected(btnCheckBox);
            }),
          );

        this.checkboxes.push(btnCheckBox);
        this.options.push(txtOption);
      }
    }

    this.btnShowAnswer = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 300,
        "btn-next-bw",
      )
      .setScale(1.5)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnShowAnswer, () => {
          this.showAnswer();
        }),
      )
      .disableInteractive();

    this.btnNext = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 300,
        "btn-next",
      )
      .setScale(1.5)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, this.btnNext, () => {
          this.backToBoard();
        }),
      )
      .setVisible(false);
  }

  checkboxSelected(selected) {
    if (this.question.correct_answer.includes(",")) {
      if (selected.texture.key === "checkbox-bw") {
        selected.setTexture("checkbox");
        this.value.push(selected.getData("option"));
      } else {
        selected.setTexture("checkbox-bw");
        const selectionRemove = this.value.indexOf(selected.getData("option"));
        if (selectionRemove !== -1) this.value.splice(selectionRemove, 1);
      }
    } else {
      this.checkboxes.forEach((checkbox) => {
        checkbox.getData("option") !== selected.getData("option")
          ? checkbox.setTexture("checkbox-bw")
          : checkbox.setTexture("checkbox");
      });
      this.value.pop();
      this.value.push(selected.getData("option"));
    }
  }

  showAnswer() {
    this.options.forEach((option) => {
      option.destroy();
    });

    this.checkboxes.forEach((checkbox) => {
      checkbox.destroy();
    });

    this.txtTop.setY(this.txtTop.y + 125);
    this.txtTop.text = this.question.feedback;

    this.correctAnswer = this.question.correct_answer.split(",");
    this.correctAnswer = this.correctAnswer.map((str) => parseInt(str, 10));
    const haveCommonElements = this.value.every((val) =>
      this.correctAnswer.includes(val),
    );

    if (haveCommonElements) {
      this.sndCorrect.play();
      this.add.image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 300,
        "tick",
      );
      this.isCorrect = true;
    } else {
      this.sndWrong.play();
      this.isCorrect = false;
      this.add.image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 300,
        "cross",
      );
    }

    if (config.online) {
      $.ajax({
        async: true,
        type: "post",
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
        url: "api/log-answer.php",
        data: {
          questionId: this.question.id,
          userAnswer: this.value.toString(),
          isCorrect: this.isCorrect,
        },
      });
    }

    this.btnShowAnswer.destroy();
    this.btnNext.setVisible(true);
  }

  backToBoard() {
    if (this.value !== undefined) this.value = undefined;
    this.scene.stop();
    this.scene.resume(cst.scenes.board, {
      scene: cst.scenes.questions,
      isCorrect: this.isCorrect,
      points: this.points,
      category: this.question.category,
    });
  }
}
